import { NgModule, } from '@angular/core';
import { JkgridwinComponent } from './components/jkgridwin/jkgridwin.component';
import { AgOpenwinComponent } from './components/agopenwin/agopenwin.component';
import { JkaggridComponent } from './components/jkaggrid/jkaggrid.component';
import { JkbtneditComponent } from './components/jkbtnedit/jkbtnedit.component';
import { JkmultiselectComponent } from './components/jkmultiselect/jkmultiselect.component';
import { JkrangeComponent } from './components/jkrange/jkrange.component';
import { ReportviewComponent } from './components/reportview/reportview.component';
import { SpeechAlarmComponent } from './components/speech-alarm/speech-alarm.component';
import { JkBatchComponent } from './components/jkBatch';
import { JkBillFormComponent } from './components/jkBillForm.component';
import { jkQueryComponent } from './components/jkQuery';
import { JkReportComponent } from './components/jkReport';
import { jkSingleComponent } from './components/jkSingle';
import { JkSingleTableComponent } from './components/JkSingleTable.component';



@NgModule(
    {
        providers: [
        ],
        imports: [
            AgOpenwinComponent, JkgridwinComponent, JkaggridComponent, AgOpenwinComponent, JkbtneditComponent,
            JkmultiselectComponent, JkrangeComponent, ReportviewComponent, SpeechAlarmComponent, JkBatchComponent,
            JkBillFormComponent, jkQueryComponent, JkReportComponent, jkSingleComponent, JkSingleTableComponent

        ],
        declarations: [
            //AutoResizeDirective, // 声明 Directive
        ],
        exports: [
            AgOpenwinComponent, JkgridwinComponent, JkaggridComponent, AgOpenwinComponent, JkbtneditComponent,
            JkmultiselectComponent, JkrangeComponent, ReportviewComponent, SpeechAlarmComponent, JkBatchComponent,
            JkBillFormComponent, jkQueryComponent, JkReportComponent, jkSingleComponent, JkSingleTableComponent

        ]

    })
export class AdvComModule { } // 暫時不要 export.容易循環引用

